module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_pre_rolls_label-273a5ddd36961a0b01cf60498fac9ce3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/cat_pre_rolls_label.png
 ** module id = 156
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/